import React from 'react'
import styled from 'styled-components'
import AssignmentIcon from '@mui/icons-material/Assignment'

const EmptyState = ({ title, description, actionLabel, onAction }) => {
  return (
    <EmptyWrapper>
      <IconWrapper>
        <AssignmentIcon />
      </IconWrapper>
      <EmptyTitle>{title || 'No tasks found'}</EmptyTitle>
      <EmptyDescription>
        {description || 'Create a new task to get started with task management.'}
      </EmptyDescription>
      {actionLabel && onAction && (
        <CreateButton onClick={onAction}>{actionLabel}</CreateButton>
      )}
    </EmptyWrapper>
  )
}

export default EmptyState

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  svg {
    font-size: 40px;
    color: ${({ theme }) => theme.colors.grey[700]};
  }
`

const EmptyTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.haiti};
  margin: 0 0 8px 0;
`

const EmptyDescription = styled.p`
  font-size: 15px;
  color: ${({ theme }) => theme.colors.grey[800]};
  margin: 0 0 24px 0;
  max-width: 300px;
  line-height: 1.5;
`

const CreateButton = styled.button`
  padding: 12px 24px;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.primary}dd;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${({ theme }) => theme.colors.primary}40;
  }
`
